import useAxios from "./useAxios";
import Constants from '../Constants';
import { toaster } from "../utils/toast";

export const useDownloadDemandDraft = () => {
    const { postData } = useAxios();

    const download = async ({ caseId, caseName, typeOfDemandDraft }) => {
        if (!typeOfDemandDraft) {
            toaster({ message: 'Please select Type of Demand', success: false });
            return;
        }

        try {
            const { success, data, message } = await postData(Constants.ApiUrl.generate, {
                caseId,
                typeOfDemandDraft,
            });

            if (success) {
                const { wordUrl } = data;
                const link = document.createElement("a");
                link.download = `${caseName}-${typeOfDemandDraft}.docx`;
                link.href = wordUrl;
                link.click();
                toaster({ message: "File downloaded successfully", success: true });
            } else {
                toaster({ message, success });
            }
        } catch (err) {
            toaster({ message: err.message || "Download failed", success: false });
        }
    };

    return download;
};